import getDefaultRoamingTimezones from './getDefaultRoamingTimezones';
import getDefaultVisibleRoamingTimezones from './getDefaultVisibleRoamingTimezones';
import getPrimaryTimezoneLabelCloudSetting from '../selectors/getPrimaryTimezoneLabelCloudSetting';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserTimeZone } from 'owa-session-store';

export default function logTimezonesData() {
    if (!isFeatureEnabled('mon-multipleTimezones')) {
        return;
    }

    const primaryTimezoneLabel = getPrimaryTimezoneLabelCloudSetting();
    const roamingTimezones = getDefaultRoamingTimezones();
    const visibleRoamingTimezones = getDefaultVisibleRoamingTimezones();

    const timezonesCount = roamingTimezones.length + 1; // adding the primary time zone
    const visibleTimezonesCount = visibleRoamingTimezones.length + 1; // adding the primary time zone
    const timezoneLabelsCount =
        (primaryTimezoneLabel ? 1 : 0) +
        roamingTimezones.filter(timezone => !!timezone.timezoneLabel).length;

    // Check if any time zones are present multiple times
    const timezoneIds = [getUserTimeZone()].concat(
        roamingTimezones.map(timezone => timezone.timezoneId)
    );
    const uniqueTimezoneIds = new Set(timezoneIds);
    const hasDuplicatedTimezones = uniqueTimezoneIds.size !== timezoneIds.length;

    logUsage('MultipleTimezonesBootStatus', {
        timezonesCount: timezonesCount,
        visibleTimezonesCount: visibleTimezonesCount,
        timezoneLabelsCount: timezoneLabelsCount,
        primaryTimezoneLabelSet: !!primaryTimezoneLabel,
        hasDuplicatedTimezones: hasDuplicatedTimezones,
    });
}
